import React, { useState, useEffect } from "react";
import userApi from "../../HTTP/user"
import ReviewBlocks from '../Review/ReviewBlocks'; // Assurez-vous que le chemin d'importation est correct
import { deleteReview } from "../../HTTP/articles"


export const Reviews = () => {
    const user = JSON.parse(localStorage.getItem("user")); // Assurez-vous que l'utilisateur est bien récupéré ici
    const [reviews, setReviews] = useState([]); 
	useEffect(() => {
		const fetchReviews = async () => {
		  const reviewsData = await userApi.getUserReviews(user.id); // Assurez-vous que ceci renvoie un tableau 
		  setReviews(reviewsData.reviews);
		};
	  
		fetchReviews();
	  }, [user.id]);
	 
	  
	const handleDeleteReview = async (reviewId) => { 
		deleteReview(reviewId).then((res) => {
		  if(res === false) {
			alert('Error while deleting review')
			return
		  } 
		  alert('Review deleted !')
		  setReviews(currentReviews => currentReviews.filter(review => review.id !== reviewId));
		}) 
	};

	const isUserSubscribed = JSON.parse(localStorage.getItem("subscriptions")) !== null

	return (
        <>
			{
				isUserSubscribed &&  (
					<>
					<h1 className="text-center mt-8 mb-8">Mes Revues de presse</h1> 
					<div className="max-h-[80vh] overflow-y-auto ml-4 mr-4">
						<ReviewBlocks reviews={reviews}  onDeleteReview={handleDeleteReview} edition="true" displayAuthor={false}/>
					</div>
					</>
				)
			}
	</>)
}